export const FUEL_BENZIN = 'benzin' as const
export const FUEL_NAFTA = 'nafta' as const
export const FUEL_BENZIN_ELEKTRO = 'benzin_elektro' as const
export const FUEL_BENZIN_ELEKTRO_PLUG_IN = 'benzin_elektro_plug_in' as const
export const FUEL_NAFTA_ELEKTRO = 'nafta_elektro' as const
export const FUEL_NAFTA_ELEKTRO_PLUG_IN = 'nafta_elektro_plug_in' as const
export const FUEL_ELEKTRO = 'elektro' as const
export const FUEL_BENZIN_CNG = 'benzin_cng' as const
export const FUEL_BENZIN_LNG = 'benzin_lng' as const
export const FUEL_BENZIN_LPG = 'benzin_lpg' as const
export const FUEL_CNG = 'cng' as const
export const FUEL_LNG = 'lng' as const
export const FUEL_LPG = 'lpg' as const
export const FUEL_OTHER = 'other' as const

export const ALL_FUELS = [
  FUEL_BENZIN,
  FUEL_NAFTA,
  FUEL_BENZIN_ELEKTRO,
  FUEL_BENZIN_ELEKTRO_PLUG_IN,
  FUEL_NAFTA_ELEKTRO,
  FUEL_NAFTA_ELEKTRO_PLUG_IN,
  FUEL_ELEKTRO,
  FUEL_BENZIN_CNG,
  FUEL_BENZIN_LNG,
  FUEL_BENZIN_LPG,
  FUEL_CNG,
  FUEL_LNG,
  FUEL_LPG,
] as const

export type Fuel = typeof ALL_FUELS[number]

export const ALL_EXTENDED_FUELS = [
  ...ALL_FUELS,
  FUEL_OTHER,
] as const

export type ExtendedFuel = typeof ALL_EXTENDED_FUELS[number]
